import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; 
import { all_routes } from "../../../feature-module/router/all_routes";

const Loader = () => {
  const route = all_routes;
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // Dashboard paths
    const dashboardPaths = [
      route.dealsDashboard,
      route.leadsDashboard,
      route.projectDashboard,
      route.orderDashboard
    ];

    // Order paths (where loader should show)
    const orderPaths = [
      route.order,                 
      route.orderDetails,          
      route.orderHistory,          
      route.orderUpdatedHistory,   
      route.orderStatus,
      route.orderHistoryPage
    ];

    // Excluded paths (no loader here)
    const excludedPaths = [
      route.orderForm
    ];

    // ✅ Check excluded first — if matches, immediately turn off loader
    const isExcluded = excludedPaths.some(path =>
      location.pathname.startsWith(path)
    );

    if (isExcluded) {
      setShowLoader(false);
      return;
    }

    // ✅ If not excluded, then check for dashboards or orders
    const isPathWithLoader =
      dashboardPaths.includes(location.pathname) ||
      orderPaths.some(path =>
        location.pathname.startsWith(path.replace(":id", ""))
      );

    if (isPathWithLoader) {
      setShowLoader(true);
      const timeoutId = setTimeout(() => {
        setShowLoader(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    } else {
      setShowLoader(false);
    }
  }, [location.pathname]);

  return (
    <>
      {showLoader && <Preloader />}
      <div>
        {/* Your other content goes here */}
      </div>
    </>
  );
};

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;
